export default {
  debug: false,
  testing: false,
  mock: false,
  apiUrl: "api",
  authSettings: {
    clientId: "73706fb5-4189-4a28-a5e6-5feaf8548382",
    authority: "https://login.microsoftonline.com/37d206bb-7b13-48f7-bd86-0ce6843206f8/",
    apiClientId: "73706fb5-4189-4a28-a5e6-5feaf8548382",
    redirectUri: "https://travelsafe.leafdot.cz"
  },
  telemetrySettings: {
    enabled: false,
    appInsightsConnectionString: null
  }
};
